import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { DashboardProvider } from '../../../../providers/dashboard/dashboard';

/**
 * Generated class for the ClubMembersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'awaiting-validation',
  templateUrl: 'awaiting.html',
})
export class AwaitingPage {


  awaitingClubs:any = null;
  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public dashboardProvider: DashboardProvider, public toastCtrl: ToastController) {
  }

  ionViewDidLoad() {
    this.fetchAwaitingClubs();
  }

  fetchAwaitingClubs(){
    this.dashboardProvider.clubsAwaitingApproval().subscribe((res) => {
      if(res.success){
        this.awaitingClubs = res.data;
      }
    })
  }

  approveClub(club_id){
    this.dashboardProvider.approveClub(club_id).subscribe((res) => {
      if(res.success){
        let toast = this.toastCtrl.create({
          message: 'Club approuvé.',
          duration: 3000,
          position: 'top'
        });
        toast.present();
        this.fetchAwaitingClubs();
      }
    })
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

        // Decoding image buffer
        ab2str(arraybuffer) {
          return new TextDecoder("utf-8").decode(new Uint8Array(arraybuffer))
        }

}



// WEBPACK FOOTER //
// ./src/pages/employer/clubs/awaiting-validation/awaiting.ts